import React, { useEffect } from 'react';
import './App.scss';
import Header from "./auth/Header";
import Footer from "./auth/Footer";
import IndexRoute from "./routes/IndexRoute";
import { TonConnectUIProvider, useTonConnectUI } from '@tonconnect/ui-react';
import { persistReferralAddressFromEntry } from "./utils/referral";
import { persistAdsgramTrackingFromEntry } from "./utils/adsgram";
import { markRegistrationTracked, trackRegistration } from "./utils/metaPixel";
import { useMetaPixelPageView } from "./utils/useMetaPixelPageView";

function App() {
    const [tonConnectUI] = useTonConnectUI();

    useMetaPixelPageView();

    useEffect(() => {
        persistReferralAddressFromEntry();
        persistAdsgramTrackingFromEntry();
    }, []);

    // The app has no sign-up form: a user "registers" by connecting a TON wallet for the first time.
    useEffect(() => {
        let cancelled = false;
        let unsubscribe: (() => void) | undefined;

        tonConnectUI.connectionRestored
            .then((restored) => {
                if (cancelled) return;

                // A session restored on page load is a returning user, not a new registration.
                const restoredAddress = tonConnectUI.account?.address;
                if (restored && restoredAddress) {
                    markRegistrationTracked(restoredAddress);
                }

                unsubscribe = tonConnectUI.onStatusChange((wallet) => {
                    if (wallet?.account?.address) {
                        trackRegistration(wallet.account.address);
                    }
                });
            })
            .catch(() => {});

        return () => {
            cancelled = true;
            unsubscribe?.();
        };
    }, [tonConnectUI]);

    return (
        <TonConnectUIProvider manifestUrl="https://cryptolotto777.com/tonconnect-manifest.json">
            <div className="App">
                <Header />
                <div className="app-content">
                    <IndexRoute />
                </div>
                <div className="app-footer-wrapper">
                    <Footer />
                </div>
            </div>
        </TonConnectUIProvider>
    );
}

export default App;
